// extracted by mini-css-extract-plugin
export default {"overlay":"LandingPagesControls-overlay_YAtFv","overlayInner":"LandingPagesControls-overlayInner_oU0YY","overlayOpen":"LandingPagesControls-overlayOpen_AknHP"};